import { CartEvent, OrderEntry } from '@spartacus/cart/base/root'

export class WishlistAddEntryEvent extends CartEvent {
  static readonly type = 'WishlistAddEntryEvent'
  productCode?: string
  quantity?: number
}

export class WishlistAddEntrySuccessEvent extends CartEvent {
  static readonly type = 'WishlistAddEntrySuccessEvent'
  productCode?: string
  quantity?: number
  entry?: OrderEntry
  quantityAdded?: number
}

export class WishlistAddEntryFailEvent extends CartEvent {
  static readonly type = 'WishlistAddEntryFailEvent'
  productCode?: string
  quantity?: number
  error?: unknown
}

export class WishlistRemoveEntrySuccessEvent extends CartEvent {
  static readonly type = 'WishlistRemoveEntrySuccessEvent'
  entry?: OrderEntry
}

export class WishlistRemoveEntryFailEvent extends CartEvent {
  static readonly type = 'WishlistRemoveEntryFailEvent'
  entry?: OrderEntry
}

